import styled from 'styled-components'

const Column = styled('div')`
  min-height: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 150px;
  border-radius: 10px;
`

export default Column
